<!--留言-->
<template>
  <el-dialog :title="showtitle"
             :visible.sync="dialogFormVisible"
             custom-class="mini-dialog"
             center
             :append-to-body="true"
             :close-on-click-modal="false"
             :modal="true">
    <el-form :model="form" ref="form1" :rules="rules">
      <el-form-item label="" label-width="0" prop="liuyan" size="small" v-if="!rebate">
        <el-input type="textarea" :autosize="{ minRows: 5, maxRows: 10}" v-model="form.liuyan" auto-complete="off"
                  :required="true" ></el-input>
        <div v-if="showtitle == '发货备注'" style="margin-top: 8px;display: flex;gap: 8px;">
          <el-tag @click="form.liuyan += '镜架已到'" style="cursor:pointer">镜架已到</el-tag>
          <el-tag @click="form.liuyan += '镜片已到'" style="cursor:pointer">镜片已到</el-tag>
        </div>
      </el-form-item>
      <el-form-item label="" label-width="0" size="small" v-if="rebate">
          已返总额：{{rebatemoney}}<br>
          本次奖励：<el-input-number v-model="form.liuyan" :controls="false"></el-input-number><br>
          支付方式：   <el-radio-group v-model="form.currency">
        <el-radio label="转账">转账</el-radio>
        <el-radio label="现金">现金</el-radio>
        <el-radio label="余额">余额</el-radio>
      </el-radio-group>
      </el-form-item>
    </el-form>
    <div slot="footer" class="dialog-footer">
      <el-button @click="dialogFormVisible = false">取 消</el-button>
      <el-button type="primary" @click="addMessage" class="qrbtn" :loading="loading">确认</el-button>
    </div>
  </el-dialog>
</template>
<script>
  import {updateliuyan,updateRebate,savePaydetail} from '@/api/set/csagreement';
  import {saveData} from '@/api/set/handlelog';

  export default {
    name: "DataContactEdit",
    data() {
      var checkrequired = (rule, value, callback) => {
        if (value.replace(/(^\s*)|(\s*$)/g, "") === '') {
          callback(new Error('必填！'));
        } else {
          callback();
        }
      };

      return {
        dialogFormVisible: false,
        rebate:false,
        rebatemoney:0,
        controldata:'',
        showtitle: '',
        erpserial: '',
        loading:false,
        hd_status: null,
        form: {
          remark: '',
          liuyan: '',
          unitguid: '',
          currency:''
        },
        formLabelWidth: '120px',
        rules: {////////定义正则验证字段。
          liuyan: [
            {validator: checkrequired, trigger: 'blur'}
          ],
        },
      }
    },
    methods: {
      //处理日志
      handlelog() {
        var handlelog = {}
        handlelog.erpserial = this.erpserial
        handlelog.isopen = 1
        handlelog.casestepname = this.hd_status==200?'退回订单岗':this.hd_status==650?"退回客服岗":""
        if(handlelog.casestepname=='')
          return;
        handlelog.remark = this.form.liuyan
        saveData(handlelog).then(response => {
        })
      },
      show(item, showtitle, hd_status,rebate) {
        this.rebate = rebate;//是否显示返利
        this.controldata = item
        this.rebatemoney = 0;
        if (this.rebate) {
          if (item.rebate)
            this.rebatemoney = item.rebate | 0;
          this.form.liuyan = undefined;
          this.form.currency = '';
          this.loading = false;
        } else {
          this.initForm();
          this.form.liuyan = ''
        }
        if (showtitle == null || showtitle == '')
          showtitle = '留言';
        else if(showtitle=='sendorder'){
          showtitle = '发货备注';
        }
        this.showtitle = showtitle;
        this.hd_status = hd_status;
        this.form.unitguid = item.unitguid;
        this.erpserial = item.erpserial;
        this.form.remark = item.remark;
        this.dialogFormVisible = true;
      },
      postPaydetail(){//提交到财务待审核表
        var now=new Date();
        var remark=this.controldata.erpserial+' （实付'+this.controldata.htje+'元） ';
        if(this.controldata.jxcformdetailDOList.length>0) {
          remark += this.controldata.jxcformdetailDOList[0].seedname;
        }
        savePaydetail({
          categoryname: "销售奖励",
          categorycode: "006",
          feedate: now.getFullYear()+'-'+(now.getMonth()+1)+'-'+now.getDate(),//日期
          currency: this.form.currency,//支付方式
          feemoney: this.form.liuyan,//金额
          auxiliary: this.controldata.customername,//客户
          auxiliaryserial: this.controldata.customerserial,//客户编码
          remark: remark,//摘要
          independentserial: this.controldata.applybydserial,//服务中心
          dname: this.controldata.applybydname,//服务中心名称
          casestatus: "6",//状态
          erpserial:this.controldata.erpserial
        }).then();
      },
      addMessage() {
        this.$refs.form1.validate((valid) => {
          if (valid) {
            this.loading = true;

            if (this.rebate) {
              //#region 填写返利金额
              if (!this.form.liuyan || parseFloat(this.form.liuyan) == '0') {
                this.$message({
                  message: '销奖金额必须填写！',
                  type: 'error'
                })
                this.loading = false;
                return;
              }
              if (!this.form.currency || this.form.currency == '') {
                this.$message({
                  message: '支付方式必须选择！',
                  type: 'error'
                })
                this.loading = false;
                return;
              }
              this.controldata.rebate = (parseFloat(this.rebatemoney) + parseFloat(this.form.liuyan)).toFixed(2);
              updateRebate(this.form).then(response => {
                if (response.data.code == 0) {
                  this.postPaydetail();
                  this.$message({
                    message: '保存成功',
                    type: 'success'
                  })
                }
                this.dialogFormVisible = false
                this.$emit("afterLiuYan", response.data.remark, this.form.unitguid, '', '');
              });
              //#endregion
            } else {
              var row = {
                remark: this.form.remark,
                liuyan: this.form.liuyan,
                unitguid: this.form.unitguid,
                currency: this.form.currency
              };
              if (this.showtitle == '发货备注') {
                row.type = '客户留言';
              }
              updateliuyan(row).then(response => {
                if (response.data.code == 0) {
                  this.$message({
                    message: '保存成功',
                    type: 'success'
                  })
                  this.handlelog();
                }
                this.dialogFormVisible = false
                //刷新列表
                this.$emit("afterLiuYan", response.data.remark, this.form.unitguid, this.hd_status, this.erpserial)
              });
            }
          }
        })
      },
      initForm() {
        this.loading=false;
        if (this.$refs.form1 != undefined) {
          this.$refs.form1.resetFields();
        }
      }
    },
    mounted() {
    },
    components: {}
  }
</script>


<style scoped>
  .Hid {
    display: none;
  }

  .ddinfo {
    border-collapse: collapse;
    width: 100%;
    margin-top: 12px;

  }

  .ddinfo td {
    font-size: 14px;
    text-align: center;
    border: 1px solid #E0DFDF;
  }
</style>





// WEBPACK FOOTER //
// src/components/testorder/cstagreement/LiuYanEdit.vue